import type { Transaction } from "@shared/types/transaction"
import { onSnapshot, orderBy, query } from "firebase/firestore"
import { useEffect, useState } from "react"

import { transactionsRef } from "../firestore/db"
import { useAuth } from "./useAuth"

export function useTransactions(
  connectionId: string | null,
  accountId: string | null,
) {
  const { user } = useAuth()
  const [transactions, setTransactions] = useState<Transaction[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user || !connectionId || !accountId) {
      setTransactions([])
      setLoading(false)
      return
    }

    const unsubscribe = onSnapshot(
      query(
        transactionsRef(user.uid, connectionId, accountId),
        orderBy("bookingDate", "desc"),
      ),
      (snapshot) => {
        setTransactions(snapshot.docs.map((doc) => doc.data()))
        setLoading(false)
      },
      (err) => {
        console.error("useTransactions:", err)
        setLoading(false)
      },
    )

    return unsubscribe
  }, [user, connectionId, accountId])

  return { transactions, loading }
}
